import { CompetitionPlayer } from './competition-player'
import { Injectable } from '@angular/core'

@Injectable()
export class CompetitionPlayerSerializer {
  fromJson(json: any): CompetitionPlayer {
    const competitionPlayer = {
      ...json
    }

    return competitionPlayer
  }

  toJson(competitionPlayer: CompetitionPlayer): any {
    return {
      ...competitionPlayer
    }
  }
}
